// packages import
import { Backdrop, Box, Grid, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { FallingLines } from "react-loader-spinner"
import { useNavigate } from "react-router-dom"
// component import
import { AllActiveCases } from "../components/dashboard/allActiveCases"
import { Events } from "../components/dashboard/events/Events"
import { Task } from "../components/dashboard/task/Task"
// others
import { AppContext } from "../context"

export const DashboardContainer = (): JSX.Element => {
  const [show, setShow] = useState<boolean>(false)
  const { outlookUser } = useContext(AppContext)
  const navigate = useNavigate()
  const redirectUrl = localStorage.getItem('redirectUrl');

  useEffect(() => {
    redirectUrl && outlookUser && setShow(true)

    const timeId = setTimeout(() => {
      setShow(false)
      redirectUrl && outlookUser && navigate(redirectUrl)
      outlookUser && localStorage.removeItem('redirectUrl');
    }, 3000)

    return () => {
      clearTimeout(timeId)
    }
    // eslint-disable-next-line
  }, [redirectUrl, outlookUser])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Backdrop
        sx={{ color: 'white', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={show}
      >
        <Box textAlign='center'>
          <FallingLines
            color='white'
            width="100"
            visible={true}
          />
          <Typography color='white' fontSize='24px'>Redirecting you to the respective case</Typography>
        </Box>
      </Backdrop>

      <Grid container justifyContent='space-between' mt={2} spacing={3}>
        <Grid item xs={12} md={6}>
          <Task />
        </Grid>

        <Grid item xs={12} md={6}>
          <AllActiveCases />
        </Grid>

        <Grid item md={12} overflow='hidden' width='100%'>
          <Events />
        </Grid>
      </Grid>
    </>
  )
}